import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { CurrentMatchedDocState } from '../types';

/**
 * 当前匹配文档排行榜模型（通用于论文和网站）
 * @description 存储当前匹配文档排行榜状态
 */
export interface CurrentMatchedDocModel extends Model<CurrentMatchedDocState>, Disposable {

}

export const CurrentMatchedDocModel = Symbol.for('CurrentMatchedDocModel');
